// extracted by mini-css-extract-plugin
export default {"CatchmentsMapContainer":"CatchmentsMap_CatchmentsMapContainer__+JzVs","MapContainer":"CatchmentsMap_MapContainer__PLsOY"};